var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBestExchangeRateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155.5,
    height: 93.3,
    viewBox: "0 0 155.5 93.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-money-bill",
    "data-name": "Icon awesome-money-bill",
    d: "M147.725,4.5H7.775A7.776,7.776,0,0,0,0,12.275v77.75A7.776,7.776,0,0,0,7.775,97.8h139.95a7.776,7.776,0,0,0,7.775-7.775V12.275A7.776,7.776,0,0,0,147.725,4.5ZM11.662,86.138V70.588a15.549,15.549,0,0,1,15.55,15.55Zm0-54.425V16.162h15.55A15.549,15.549,0,0,1,11.662,31.712ZM77.75,74.475c-10.737,0-19.437-10.445-19.437-23.325s8.7-23.325,19.438-23.325S97.188,38.268,97.188,51.15,88.482,74.475,77.75,74.475Zm66.088,11.663h-15.55a15.549,15.549,0,0,1,15.55-15.55Zm0-54.425a15.549,15.549,0,0,1-15.55-15.55h15.55Z",
    transform: "translate(0 -4.5)",
    fill: "#1fbdfc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestExchangeRateIcon);
export default __webpack_public_path__ + "static/media/best-exchange-rate-icon.6e100320fa0421d16fb6cdbd008281ad.svg";
export { ForwardRef as ReactComponent };